import PropTypes from 'prop-types'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { Avatar, CompanyLogo, EventTypeName, Name, ProfileContainer as Container } from '@calendly/booking-kit'

const Profile = ({
  avatar = null,
  eventTypeName = null,
  logoUrl = null,
  name = null,
  reduced = false,
  sidebar = false
}) => {
  const isPhone = useDeviceType('isPhone')
  const hideWhenReduced = reduced && isPhone
  const nameTag = eventTypeName ? 'div' : 'h1'
  const logoVisible = sidebar && Boolean(logoUrl)

  return (
    <Container reducedView={reduced}>
      {logoVisible && <CompanyLogo url={logoUrl} />}
      {avatar && !hideWhenReduced && <Avatar src={avatar} alt={name} withLogo={logoVisible} sidebarView={sidebar} />}
      {name && !hideWhenReduced && <Name as={nameTag} sidebarView={sidebar}>{name}</Name>}
      {eventTypeName && <EventTypeName sidebarView={sidebar}>{eventTypeName}</EventTypeName>}
    </Container>
  )
}

Profile.propTypes = {
  avatar: PropTypes.string,
  name: PropTypes.string,
  logoUrl: PropTypes.string,
  eventTypeName: PropTypes.string,
  reduced: PropTypes.bool,
  sidebar: PropTypes.bool
}

export default Profile
